import "./App.css";
import "./common.scss";
import {
  Route,
  Routes,
  Navigate,
  useNavigate,
  useLocation,
  useSearchParams
} from "react-router-dom";
import Login from "./routes/Login/login";
import StepThree from "./routes/OrderSummary/iq-stepthree";
import Payments from "./routes/Payments/payments";
import MyOrders from "./routes/MyOrders/MyOrders";
import Myquotes from "./routes/MyQuotes/MyQuotes";
import OrderDetails from "./routes/OrderDetails/order-details";
import Profile from "./routes/Profile/profile";
import NewPassword from "./routes/SendNewPassword/sendnewpassword";
import Privacy from "./routes/Privacy/Privacy";
import Terms from "./routes/Terms/Terms";
import { useEffect } from "react";
import Quotes from "./Admin/Orders/Quotes";
import AdminQuote from "./Admin/Orders/AdminQuote";
import AdminDashboard from "./Admin/AdminDashboard";
import Order from "./Admin/Orders/Order";
import InstantQuote from "./routes/InstantQuote";
import AdminOrderDetails from "./Admin/Orders/orderDetailsAdmin";
import jwt_decode from "jwt-decode";
import PrivateRoute from "./authRoutes/Routes";
import AdminPrivateRoute from "./authRoutes/adminRoute";
import CompanyMaster from "./Admin/Users/CompanyMaster";
import UserMaster from "./Admin/Users/UserMaster";
import EditCompany from "./Admin/Users/EditCompany";
import AddCompany from "./Admin/Users/AddCompany";
import AddUser from "./Admin/Users/AddUser";
import EditUser from "./Admin/Users/EditUser";
import AdminUsers from "./Admin/Users/AdminUsers";
import LayerThicknessMaster from "./Admin/Masters/LayerThicknessMaster";
import MaterialMaster from "./Admin/Masters/MaterialMaster";
import SubMaterialMaster from "./Admin/Masters/SubMaterialMaster";
import PartMakingMaster from "./Admin/Masters/PartMakingMaster";
import SurfaceFinishMaster from "./Admin/Masters/SurfaceFinishMaster";
import SurfaceTreatmentMaster from "./Admin/Masters/SurfaceTreatmentMaster";
import ToleranceMaster from "./Admin/Masters/ToleranceMaster";
import AddLayerThicknessMaster from "./Admin/Masters/AddMasters/AddLayerThicknessMaster";
import EditLayerThicknessMaster from "./Admin/Masters/EditMasters/EditLayerThicknessMaster";
import AddMaterialMaster from "./Admin/Masters/AddMasters/AddMaterialMaster";
import EditMaterialMaster from "./Admin/Masters/EditMasters/EditMaterialMaster";
import AddSubmaterialMaster from "./Admin/Masters/AddMasters/AddSubmaterialMaster";
import EditSubmaterialMaster from "./Admin/Masters/EditMasters/EditSubmaterialMaster";
import AddPartMakingMaster from "./Admin/Masters/AddMasters/AddPartMakingMaster";
import EditPartMakingMaster from "./Admin/Masters/EditMasters/EditPartMakingMaster";
import AddSurfaceFinishMaster from "./Admin/Masters/AddMasters/AddSurfaceFinishMaster";
import AddSurfaceTreatmentMaster from "./Admin/Masters/AddMasters/AddSurfaceTreatmentMaster";
import EditSurfaceTreatmentMaster from "./Admin/Masters/EditMasters/EditSurfaceTreatmentMaster";
import AddToleranceMaster from "./Admin/Masters/AddMasters/AddToleranceMaster";
import EditToleranceMaster from "./Admin/Masters/EditMasters/EditToleranceMaster";
import EditSurfaceFinishMaster from "./Admin/Masters/EditMasters/EditSurfaceFinishMaster";
import EditAdminUser from "./Admin/Users/EditAdminUser";
import QuoteVersion from "./routes/QuoteVersions/QuoteVersion";
import PurchaseOrderIssue from "./Admin/Issues/PurchaseOrderIssue";
import QualityIssue from "./Admin/Issues/QualityIssue";
import OptionDashboard from "./routes/OptionDashboard/optionDashboard";
import "react-toggle/style.css";
import AddressModal from "./components/AddressModal/AddressModal";
import BulkPricing from "./Admin/BulkPricing";
import ViewOrderDetails from "./routes/ViewOrderDetails/viewOrderDetails";
import ProjectName from "./routes/ProjectName/projectName";
import qs from "query-string";
import Maintanence from "./routes/Maintanence";
import ManualQuote from "./routes/ManualQuote/manualQuote";
import OptionOneSelection from "./routes/OptionOneSelection/optionOneSelection";
import PurchaseOrderDetails from "./Admin/Orders/PurchaseOrderDetails";
import PurchaseOrders from "./Admin/Orders/PurchaseOrders";
import SupplierCompanyMaster from "./Admin/Users/SupplierCompanyMaster";
import SupplierUserMaster from "./Admin/Users/SupplierUserMaster";
import AddSupplierCompany from "./Admin/Users/AddSupplierCompany";
import AddSupplierUser from "./Admin/Users/AddSupplierUser";
import RFQs from "./Admin/Orders/RFQs";
import DainstaAddressMaster from "./Admin/Masters/DainstaAddressMaster";
import EmailTracking from "./Admin/Masters/EmailTracking";
import RFQDetails from "./Admin/Orders/RFQDetails";
import CSR from "./routes/CSR/CSR";
import { pathNameForPublicAccess } from "./utils/constant";
import Projects from "./routes/Projects/Projects";
import ProjectCategoryGrid from "./routes/Projects/ProjectCategoryGrid/ProjectCategoryGrid";
import ThreeDProjects from "./routes/Projects/ThreeDProjects/ThreeDProjects";
import CastingProjects from "./routes/Projects/CastingProjects/CastingProjects";
import CNCMachiningProjects from "./routes/Projects/CNCMachiningProjects/CNCMachiningProjects";
import PackagingProjects from "./routes/Projects/PackagingProjects/PackagingProjects";
import CompleteAssemblyProjects from "./routes/Projects/CompleteAssemblyProjects/CompleteAssemblyProjects";
import { USER_ACTIONS, useUserContext } from "./context/user.context";
import { getPredictedValueForPartToLoad } from "./utils/actions/commanActions";
import SupplierBillsMaster from "./Admin/InvoiceBill/SupplierBillsMaster";
import CustomerInvoiceMaster from "./Admin/InvoiceBill/CustomerInvoiceMaster";
import InvoiceDetails from "./Admin/InvoiceBill/InvoiceDetails";
import BillDetails from "./Admin/InvoiceBill/BillDetails";
import Dashboard from "./routes/Dashboard/dashboard";
import AdminDashboardNew from "./Admin/AdminDashboardNew";
import { verifySso } from "./utils/actions/loginactions";

function App() {
  let loggedIn = localStorage.getItem("isLoggedIn");
  let token = localStorage.getItem("Token");
  const navigate = useNavigate();
  const location = useLocation();
  const { state, dispatch } = useUserContext();
  const [searchParams] = useSearchParams();

  const handleLogout = () => {
    localStorage.removeItem("Token");
    localStorage.removeItem("_id");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("isLoggedIn");
    navigate("/");
    return;
  };
  useEffect(() => {
    // Get the full URL of the current page
    const url = new URL(window.location.href);

    // Use URLSearchParams to parse the query string
    const queryParams = new URLSearchParams(url.search);

    // Extract the token from the query parameter 'sso'
    const tokenParam = queryParams.get('sso');
    if (tokenParam) {
      const parsedToken = JSON.parse(tokenParam);
      (async () => {
        const response = await verifySso(parsedToken);
        console.log("Response ::", response);
        if (!response?.status) {
          navigate('/login');
          return;
        }
        //user if valid login
        localStorage.setItem("Token", JSON.stringify(response?.data?.token));
        localStorage.setItem("firstName", response?.data?.firstName);
        localStorage.setItem("lastName", response?.data?.lastName);
        localStorage.setItem("email", response?.data?.email);
        localStorage.setItem("_id", response?.data?._id);
        localStorage.setItem("isLoggedIn", true);
        localStorage.setItem(
          "tokenValidTill",
          new Date(Date.now() + 86400000 * 30).valueOf()
        );
        sessionStorage.setItem("isLoggedIn", true);
        navigate('/my-orders');
      })()
    }
  }, []);

  // useEffect(() => {
  //   //check if sso token is there 

  //   token = localStorage.getItem("Token");
  //   const isLoggedIn = localStorage.getItem("isLoggedIn");
  //   if (!token) {
  //     if (!location.pathname.includes("verifyEmail")) {
  //       handleLogout();
  //     }
  //   } else {
  //     let decode = jwt_decode(token);
  //     if (decode.exp * 1000 < Date.now()) {
  //       handleLogout();
  //     }
  //     if (decode.exp * 1000 - Date.now() < 1800) {
  //       handleLogout();
  //     }
  //   }

  //   if (isLoggedIn != "true" && !location.pathname.includes("verifyEmail")) {
  //     handleLogout();
  //   }

  //   const { search } = window.location;
  //   const param = qs.parse(search);
  //   if (param.redirected_url && token) {
  //     window.href = param.redirected_url + search;
  //   }

  //   if (
  //     pathNameForPublicAccess.includes(location.pathname) ||
  //     location.pathname.includes("/view-order-details/") ||
  //     location.pathname.includes("/projects")
  //   ) {
  //     navigate(location.pathname);
  //   }

  //   getPredictedValueForPartToLoad(token)
  //     .then(() => {
  //       console.log("ML API Loaded");
  //     })
  //     .catch(() => {
  //       console.log("Error on page load ML api call.");
  //     });
  // }, []);

  useEffect(() => {
    console.log(
      window.location.host,
      "make.dainsta.com",
      window.location.host === "make.dainsta.com"
        ? "Gtm loaded"
        : "GTM not loaded"
    );
    if (window.location.host === "make.dainsta.com") {
      loadGTM();
    }
  }, []);

  const loadGTM = () => {
    const gtmScript = document.createElement("script");
    gtmScript.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://insights.dainsta.com/gtm.js?st='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','M9FSQD8');`;
    document.head.appendChild(gtmScript);
  };

  return (
    <Routes>
      {!loggedIn && !token && <Route path="/" element={<Login />}></Route>}
      <Route path="/" element={<Login />}></Route>
      <Route path="/:id/verifyEmail" element={<NewPassword />}></Route>
      <Route path="/dashboard" element={<PrivateRoute />}>
        <Route path="/dashboard" element={<Dashboard />} />
      </Route>

      <Route path="/dashboard/option" element={<PrivateRoute />}>
        <Route path="/dashboard/option" element={<OptionDashboard />} />
      </Route>

      <Route path="/dashboard/option-one" element={<PrivateRoute />}>
        <Route path="/dashboard/option-one" element={<OptionOneSelection />} />
      </Route>

      <Route path="/project-name" element={<PrivateRoute />}>
        <Route path="/project-name" element={<ProjectName />} />
      </Route>

      <Route path="/modal" element={<AddressModal />} />

      <Route path="/get-instant-quote/checkout/:_id" element={<PrivateRoute />}>
        <Route
          path="/get-instant-quote/checkout/:_id"
          element={<StepThree />}
        />
      </Route>

      <Route path="/get-instant-quote" element={<PrivateRoute />}>
        <Route path="/get-instant-quote" element={<InstantQuote />} />
      </Route>

      <Route path="/get-instant-quote/:_id" element={<PrivateRoute />}>
        <Route path="/get-instant-quote/:_id" element={<InstantQuote />} />
      </Route>

      <Route path="/payments/:_id" element={<PrivateRoute />}>
        <Route path="/payments/:_id" element={<Payments />}></Route>
      </Route>

      <Route path="/my-orders" element={<PrivateRoute />}>
        <Route path="/my-orders" element={<MyOrders />}></Route>
      </Route>

      <Route path="/saved-quote" element={<PrivateRoute />}>
        <Route path="/saved-quote" element={<Myquotes />}></Route>
      </Route>

      <Route path="/quote-versions/:RefId" element={<PrivateRoute />}>
        <Route path="/quote-versions/:RefId" element={<QuoteVersion />}></Route>
      </Route>

      <Route path="/manual-quote/:_id" element={<PrivateRoute />}>
        <Route path="/manual-quote/:_id" element={<ManualQuote />} />
      </Route>

      <Route path="/order-details/:_id" element={<PrivateRoute />}>
        <Route path="/order-details/:_id" element={<OrderDetails />}></Route>
      </Route>

      <Route path="/profile" element={<PrivateRoute />}>
        <Route path="/profile" element={<Profile />}></Route>
      </Route>

      <Route path="/privacy-policy" element={<Privacy />}></Route>
      <Route path="/terms-of-service" element={<Terms />}></Route>
      <Route path="/Sustainability-CSR" element={<CSR />}></Route>
      <Route path="/view-order-details/:_id" element={<ViewOrderDetails />} />
      <Route path="/projects" element={<Projects />}>
        <Route index element={<ProjectCategoryGrid />} />
        <Route path="/projects/three-d-printing" element={<ThreeDProjects />} />
        <Route path="/projects/casting" element={<CastingProjects />} />
        <Route
          path="/projects/cnc-machining"
          element={<CNCMachiningProjects />}
        />
        <Route
          path="/projects/complete-assembly"
          element={<CompleteAssemblyProjects />}
        />
        <Route path="/projects/packaging" element={<PackagingProjects />} />
      </Route>

      {/* Admin routes */}

      <Route
        path="/admin/email-tracking"
        element={<AdminPrivateRoute title="Email Tracking" />}
      >
        <Route
          path="/admin/email-tracking"
          element={<EmailTracking title="Email Tracking" />}
        ></Route>
      </Route>

      <Route path="/admin/quotes" element={<AdminPrivateRoute />}>
        <Route path="/admin/quotes" element={<Quotes />}></Route>
      </Route>
      {/* =================Test-Route-Start========================== */}
      {/* <Route path="/admin/quotes" element={<AdminPrivateRoute />}>
        <Route path="/admin/quotes" element={<Quotes />}></Route>
      </Route> */}
      {/* =================Test-Route-End========================== */}

      <Route path="/admin/supplier-bills" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/supplier-bills"
          element={<SupplierBillsMaster />}
        ></Route>
      </Route>

      <Route path="/admin/customer-invoices" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/customer-invoices"
          element={<CustomerInvoiceMaster />}
        ></Route>
      </Route>
      {/* <Route path="/test" element={} /> */}

      <Route path="/admin/bill-details/:id" element={<AdminPrivateRoute />}>
        <Route path="/admin/bill-details/:id" element={<BillDetails />}></Route>
      </Route>

      <Route path="/admin/invoice-details/:id" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/invoice-details/:id"
          element={<InvoiceDetails />}
        ></Route>
      </Route>

      <Route path="/admin/rfqs" element={<AdminPrivateRoute />}>
        <Route path="/admin/rfqs" element={<RFQs />}></Route>
      </Route>

      <Route path="/admin/admin-quote/:_id" element={<AdminPrivateRoute />}>
        <Route path="/admin/admin-quote/:_id" element={<AdminQuote />}></Route>
      </Route>

      <Route path="/admin/rfq-details/:_id" element={<AdminPrivateRoute />}>
        <Route path="/admin/rfq-details/:_id" element={<RFQDetails />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin" element={<AdminDashboardNew />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/company-master" element={<CompanyMaster />}></Route>
      </Route>
      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/bulk-pricing" element={<BulkPricing />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/dainsta-address"
          element={<DainstaAddressMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/edit-company" element={<EditCompany />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/add-company" element={<AddCompany />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/add-user" element={<AddUser />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/edit-user" element={<EditUser />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/user-master" element={<UserMaster />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/admin-users" element={<AdminUsers />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-admin-user"
          element={<EditAdminUser />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/purchase-orders"
          element={<PurchaseOrders />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/supplier-company-master"
          element={<SupplierCompanyMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/supplier-user-master"
          element={<SupplierUserMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/purchase-order-details/:_id"
          element={<PurchaseOrderDetails />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-supplier-user"
          element={<AddSupplierUser />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-supplier-user/:_id"
          element={<AddSupplierUser />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-supplier-company"
          element={<AddSupplierCompany />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-supplier-company/:_id"
          element={<AddSupplierCompany />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/product-related-issues"
          element={<PurchaseOrderIssue />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/quality-related-issues"
          element={<QualityIssue />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/material" element={<MaterialMaster />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-material-master"
          element={<AddMaterialMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-material-master"
          element={<EditMaterialMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/subMaterial"
          element={<SubMaterialMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-submaterial-master"
          element={<AddSubmaterialMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-submaterial-master"
          element={<EditSubmaterialMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/partMaking" element={<PartMakingMaster />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-partmaking-master"
          element={<AddPartMakingMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-partmaking-master"
          element={<EditPartMakingMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/surface-finish"
          element={<SurfaceFinishMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-surface-finish-master"
          element={<AddSurfaceFinishMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-surface-finish-master"
          element={<EditSurfaceFinishMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/surface-treatment"
          element={<SurfaceTreatmentMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-surface-treatment-master"
          element={<AddSurfaceTreatmentMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-surface-treatment-master"
          element={<EditSurfaceTreatmentMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/layer-thickness"
          element={<LayerThicknessMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-layer-thickness"
          element={<AddLayerThicknessMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-layer-thickness"
          element={<EditLayerThicknessMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route path="/admin/tolerance" element={<ToleranceMaster />}></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/add-tolerance-master"
          element={<AddToleranceMaster />}
        ></Route>
      </Route>

      <Route path="/admin" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/edit-tolerance-master"
          element={<EditToleranceMaster />}
        ></Route>
      </Route>

      <Route path="/admin/orders" element={<AdminPrivateRoute />}>
        <Route path="/admin/orders" element={<Order />}></Route>
      </Route>

      <Route path="/admin/orders/:_id" element={<AdminPrivateRoute />}>
        <Route
          path="/admin/orders/:_id"
          element={<AdminOrderDetails />}
        ></Route>
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
